import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Plus: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 7c.6 0 1 .4 1 1v7h7a1 1 0 1 1 0 2h-7v7a1 1 0 1 1-2 0v-7H8a1 1 0 1 1 0-2h7V8c0-.6.4-1 1-1Z"
      clipRule="evenodd"
    />
  </Icon>
);
